import exponent from "./exponent.js";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/precisionFixed.js
// module id = 847
// module chunks = 0 1